const initialState = null;

const sharedSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SHARED_SEARCH':
      return action.payload;
    default:
      return state;
  }
};

export default sharedSearchReducer;
